import i18n from '@/i18n';
import { regexEmail } from '@/utils/regex';
import { validateAllField } from '@/utils/validate_v2';

const initFormPageI = () => {
    return {
        email: '',
        mail_confirm: ''
    };
};

const configFormPageI = () => {
    return {
        email: {
            name: 'email',
            autocomplete: 'on',
            classCustom: '',
            placeholder: '',
            error: false,
            errorCustomMess: '',
            errorField: i18n.t('managerForm.settingPage.pageTypeI.fieldMail'),
            messageCustom: true,
            typesValidate: ['required', 'email', 'max255']
        },
        mail_confirm: {
            name: 'confirm_email',
            autocomplete: 'on',
            classCustom: '',
            error: false,
            placeholder: '',
            errorCustomMess: '',
            errorField: i18n.t('managerForm.settingPage.pageTypeI.fieldMail'),
            messageCustom: true,
            typesValidate: ['email', 'max255']
        }
    };
};

const onHandleMapMessage = (field, config) => {
    const valueField = field.trim();
    let checkValid = true;
    for (const validateType of config.typesValidate) {
        switch (validateType) {
            case 'required':
                if (!valueField) {
                    config.error = true;
                    checkValid = false;
                    config.errorField = '必ず入力してください。';
                    return false;
                }
                break;
            case 'email':
                if (!!valueField && !regexEmail(valueField)) {
                    config.error = true;
                    checkValid = false;
                    config.errorField = 'メールアドレスを正しい形式で入力してください。';
                    return false;
                }
                break;
            case 'max255':
                if (!!valueField && valueField.length > 255) {
                    config.error = true;
                    checkValid = false;
                    config.errorField = `メールアドレスを255文字以内で入力してください。`;
                    return false;
                }
                break;
        }
    }
    return checkValid;
};

const onHandleMessKeypattern = (allForm, allConfig, resData) => {
    if (resData?.form_pages?.page_registration_mail?.extension?.confirm_input_twice && allForm.email.toString() !== allForm.mail_confirm.toString()) {
        allConfig.email.error = true;
        allConfig.email.errorField = '入力した内容が一致しません。';
        return false;
    }
    return true;
};

const handleValidateAllField = (allForm, allConfig, dataRes) => {
    let checkAll = validateAllField(allForm, allConfig);
    for (const field in allForm) {
        allForm[field] = allForm[field].trim();
        checkAll = onHandleMapMessage(allForm[field], allConfig[field]) && checkAll;
    }
    checkAll = onHandleMessKeypattern(allForm, allConfig, dataRes) && checkAll;
    return checkAll;
};

export { initFormPageI, configFormPageI, onHandleMapMessage, handleValidateAllField, onHandleMessKeypattern };
